<template>
  <div>
    <b-field expanded grouped group-multiline class="mobile-search mb-3">
      <b-field expanded  class="my-2 control">
        <search
          v-model="query.filter.address"
          @selectProperty="(item) => $emit('selectProperty', item)"
          @selectListing="(item) => $emit('selectListing', item)"
          @search="apply()"
          @selectCity="(city) => $emit('selectCity', city)"
          @selectAddress="(city) => $emit('selectAddress', city)"
        ></search>
      </b-field>
<!--      <a-->
<!--        v-bind:class="{ 'has-background-info-light': hasMoreFilter() }"-->
<!--        class="navbar-item ml-2"-->
<!--        role="button"-->
<!--        @click.stop="isMoreFilterModalActive = true"-->
<!--      >-->
<!--        <span>More</span>-->
<!--        <b-icon icon="menu-down"></b-icon>-->
<!--        <div class="b-icon-no-text" @click.stop="clearMoreFilter(); apply()">-->
<!--          <b-icon-->
<!--            v-if="hasMoreFilter()" icon="close-circle"></b-icon>-->
<!--        </div>-->
<!--      </a>-->
    </b-field>

  <b-modal
    v-model="isMoreFilterModalActive"
    has-modal-card
    trap-focus
    :destroy-on-hide="false"
    aria-role="dialog"
    aria-label="More filters"
    close-button-aria-label="Close"
    aria-modal
    class="moreFilterModal"
    can-cancel
    ref="more_filter"
    full-screen
  >

    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">Filters:</p>
        <button
          type="button"
          class="delete"
          @click="isMoreFilterModalActive = false"/>
      </header>
      <section class="modal-card-body">
        <b-field class="my-2 control" label="Price range">
          <b-select class="mr-2" v-model="query.filter.price.min">
            <option :value="null">No min</option>
            <option :value="option" v-for="(option, index) in price_range_suggest[query.filter.deal_type ? query.filter.deal_type : 'BUY'].min" v-bind:key="index">
              {{option}}
            </option>

          </b-select>

          <b-select class="ml-2" v-model="query.filter.price.max">
            <option :value="null">No max</option>
            <template v-for="(option, index) in price_range_suggest[query.filter.deal_type ? query.filter.deal_type : 'BUY'].max">
              <option v-if="option >= query.filter.price.min" :value="option"  v-bind:key="index">
                {{option}}
              </option>
            </template>
          </b-select>
        </b-field>
        <b-field class="my-2 control" label="Property type">
          <div class="container">
            <div class="row mb-2">
              <div class="col-md-6">
                <b-radio v-model="query.filter.property_type"
                         :native-value="null">
                  Any
                </b-radio>
              </div>
              <div class="col-md-6">
                <b-radio v-model="query.filter.property_type"
                         native-value="RINC">
                  Multi-Family
                </b-radio>
              </div>

              <div class="col-md-6">
                <b-radio v-model="query.filter.property_type"
                         native-value="FARM">
                  Farm
                </b-radio>
              </div>
              <div class="col-md-6">
                <b-radio v-model="query.filter.property_type"
                         native-value="RLSE">
                  Residential Lease
                </b-radio>
              </div>

              <div class="col-md-6">
                <b-radio v-model="query.filter.property_type"
                         native-value="RESI">
                  Residential
                </b-radio>
              </div>
              <div class="col-md-6">
                <b-radio v-model="query.filter.property_type"
                         native-value="BUSO">
                  Business Opportunity
                </b-radio>
              </div>

              <div class="col-md-6">
                <b-radio v-model="query.filter.property_type"
                         native-value="COMS">
                  Commercial Sale
                </b-radio>
              </div>
              <div class="col-md-6">
                <b-radio v-model="query.filter.property_type"
                         native-value="COML">
                  Commercial Lease
                </b-radio>
              </div>

              <div class="col-md-6">
                <b-radio v-model="query.filter.property_type"
                         native-value="LAND">
                  Land
                </b-radio>
              </div>
              <div class="col-md-6">
                <b-radio v-model="query.filter.property_type"
                         native-value="OTHER">
                  Other
                </b-radio>
              </div>
            </div>

          </div>
        </b-field>

        <b-field class="my-2 control" label="Deal type">
          <div class="container">
            <div class="row mb-2">
              <div class="col-md-6">
                <b-radio v-model="query.filter.deal_type"
                         :native-value="null">
                  Any
                </b-radio>
              </div>
              <div class="col-md-6">
                <b-radio v-model="query.filter.deal_type"
                         native-value="BUY">
                  For sale
                </b-radio>
              </div>

              <div class="col-md-6">
                <b-radio v-model="query.filter.deal_type"
                         native-value="RENT">
                  For rent
                </b-radio>
              </div>
            </div>
          </div>
        </b-field>

        <b-field class="my-2 control" label="Bedrooms">
          <b-select class="mr-2" v-model="query.filter.bedroom.min">
            <option :value="null">No min</option>
            <option :value="option" v-for="(option, index) in bedroom_suggest.min" v-bind:key="index">
              {{option}}
            </option>

          </b-select>

          <b-select class="ml-2" v-model="query.filter.bedroom.max">
            <option :value="null">No max</option>
            <template v-for="(option, index) in bedroom_suggest.max">
              <option v-if="option >= query.filter.bedroom.min" :value="option"  v-bind:key="index">
                {{option}}
              </option>
            </template>
          </b-select>
        </b-field>


        <b-field class="my-2 control" label="Baths">
          <div class="container">
            <div class="row mb-2">
              <div class="col-md-6">
                <b-radio v-model="query.filter.bathroom.min"
                         :native-value="null">
                  Any
                </b-radio>
              </div>
              <div class="col-md-6">
                <b-radio v-model="query.filter.bathroom.min"
                         :native-value="1">
                  1+ Bathrooms
                </b-radio>
              </div>

              <div class="col-md-6">
                <b-radio v-model="query.filter.bathroom.min"
                         :native-value="2">
                  2+ Bathrooms
                </b-radio>
              </div>
              <div class="col-md-6">
                <b-radio v-model="query.filter.bathroom.min"
                         :native-value="3">
                  3+ Bathrooms
                </b-radio>
              </div>
            </div>
          </div>
        </b-field>
        <b-field class="my-2 control" label="Square Feet">
          <b-select class="mr-2" v-model="query.filter.square.min">
            <option :value="null">No min</option>
            <option :value="option" v-for="(option, index) in square_suggest.min" v-bind:key="index">
              {{option}}
            </option>

          </b-select>

          <b-select class="ml-2" v-model="query.filter.square.max">
            <option :value="null">No max</option>
            <template v-for="(option, index) in square_suggest.max">
              <option v-if="option >= query.filter.square.min" :value="option"  v-bind:key="index">
                {{option}}
              </option>
            </template>
          </b-select>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <b-button
          label="Clear"
          @click.stop="clearMoreFilter()" />
        <b-button
          label="Apply"
          type="is-primary"
          @click.stop="apply(); isMoreFilterModalActive = false;"
        />
      </footer>
    </div>


  </b-modal>
</div>
</template>

<script>
// import {mapActions} from 'vuex';
// import { mapFields } from 'vuex-map-fields';
// import {getCityById, getPropertiesByQuery} from "@/components/front/realty/repository";
// import {Result} from "@/components/front/realty/propertiesQueryResult";
// import {Query} from "@/components/front/realty/propertiesQueryBuilder";
// import detail from "@/components/front/realty/detail/detailv2";
// import leaflet from "@/components/front/realty/realtor_properties_list/map/leaflet";
// import _ from 'lodash';
// import FixedHeader from 'vue-fixed-header'
// import configDefault from "@/components/front/realty/realtor_properties_list/map/config";
// import {localCache} from "@/components/front/realty/localCache";
import search from "@/components/listings_map/search/input";
// import fullDetail from "@/components/front/realty/realtor_properties_detail/index";

export default {
  name: 'front_realty_realtor_properties_list',
  components: { search},

  props: {
    value:null
  },
  data() {
    return {
      square_suggest: {
        min:[
          400,
          500,
          600,
          700,
          800,
          900,
          1000,
          1100,
          1200,
          1300,
          1400,
          1500,
          1600,
          1700,
          1800,
          1900,
          2000,
          2500,
          3000,
          3500,
          4000,
          4500
        ],
        max:[
          400,
          500,
          600,
          700,
          800,
          900,
          1000,
          1100,
          1200,
          1300,
          1400,
          1500,
          1600,
          1700,
          1800,
          1900,
          2000,
          2500,
          3000,
          3500,
          4000,
          4500
        ],
      },
      isMoreFilterModalActive: false,
      bedroom_suggest_mode: "min",
      bedroom_suggest: {
        min : {
          "1+ Bed" : 1,
          "2+ Beds" : 2,
          "3+ Beds" : 3,
          "4+ Beds" : 4
        },
        max: {
          "1 Bed" : 1,
          "2 Beds" : 2,
          "3 Beds" : 3,
          "4 Beds" : 4
        }
      },
      price_range_suggest_mode: "min",
      price_range_suggest:{
        "BUY": {
          "min" : [
            40000,
            80000,
            100000,
            120000,
            150000,
            180000
          ],
          "max" : [
            150000,
            180000,
            200000,
            250000,
            300000,
            450000,
          ]
        },
        "RENT": {
          "min" : [
              800,
              1000,
              1300,
              1500,
              1700,
              2000
            ],
          "max" : [
            1000,
            1300,
            1500,
            1800,
            2000,
            2300
          ]
        },
      },
      deal_map : {
        "BUY": "For sale",
        "RENT" : "For rent"
      },
      property_type_map : {
        "RINC": "Multi-Family",
        "FARM" : "Farm",
        "RLSE" : "Residential Lease",
        "RESI" : "Residential",
        "BUSO" : "Business Opportunity",
        "COMS" : "Commercial Sale",
        "COML" : "Commercial Lease",
        "LAND" : "Land",
        "OTHER" : "OTHER"
      },
    }
  },
  computed: {
    query: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {

    hasMoreFilter() {
      return  this.query.filter.bathroom.min || this.query.filter.bathroom.max
        || this.query.filter.square.min || this.query.filter.square.max
        || this.query.filter.bedroom.min || this.query.filter.bedroom.max
        || this.query.filter.price.min || this.query.filter.price.max
        || this.query.filter.property_type || this.query.filter.deal_type;
    },
    clearMoreFilter() {
      this.query.filter.bathroom.min = null;
      this.query.filter.bathroom.max = null;
      this.query.filter.square.min = null;
      this.query.filter.square.max = null;
      this.query.filter.bedroom.min = null;
      this.query.filter.bedroom.max = null;
      this.query.filter.price.min = null;
      this.query.filter.price.max = null;
      this.query.filter.property_type = null;
      this.query.filter.deal_type = null;
    },
    bedroomMinClick(option) {
      this.query.filter.bedroom.min = option;
      //this.bedroom_suggest_mode = 'max'
      this.$refs['bedroom_suggest_mode_max'].focus();
    },
    bedroomMaxClick(option) {
      this.query.filter.bedroom.max = option;
      this.apply('bedroom_filter');
    },
    priceRangeMinClick(option) {
      this.query.filter.price.min = option;
      this.price_range_suggest_mode = 'max'
      this.$refs['price_range_suggest_mode_max'].focus();
    },
    priceRangeMaxClick(option) {
      this.query.filter.price.max = option;
      this.apply('price_range_filter');
    },
    money(val) {
      return parseInt(val).toLocaleString('en-US', { style: 'currency', currency: 'USD',  minimumFractionDigits: 0,
        maximumFractionDigits: 0 });
    },
    kFormatter(num) {
      return Math.abs(num) > 3000 ? Math.sign(num)*((Math.abs(num)/1000).toFixed(1)) + 'k' : this.money(Math.sign(num)*Math.abs(num))
    },
    apply(ref){
      if(ref){
        this.$refs[ref].toggle();
      }
      this.$emit('apply', ref)
    }
  },
  created() {

  },
  mounted() {

  },
  unmounted() {

  },
  beforeDestroy() {

  },
  watch: {

  },
}
</script>

<style scoped>

.price-range-suggest-item {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  cursor: pointer;
  padding-left: 20px;
  padding-right: 20px;
}

.price-range-suggest-item:hover {
  background: #f2f2f2;
}

.price-range-suggest-box {
  margin-left: -20px;
  margin-right: -20px;
}
.b-icon-no-text{
  display: inline-block;
  height: 24px;
  margin-left: 0.5rem;
}
</style>
<style>
.mobile-search .field.is-grouped.is-grouped-multiline:last-child{
  margin-bottom: -1rem;
}
</style>
